import React, { useEffect, useState } from 'react';
import Logo from '@/assets/logo.svg';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { IPrescription } from '@/types';
import Verification from './Steps/Verification';

const Application: React.FC = () => {
  const code = window.location.pathname.split('/').pop()?.toLocaleLowerCase() || '';
  const [isValidated, setIsValidated] = useState<boolean>(false);
  const [prescription, setPrescription] = useState<IPrescription | null>(null);

  useEffect(() => {
    if (
      isValidated &&
      prescription &&
      prescription.user &&
      prescription.user.id &&
      prescription.request &&
      prescription.request.id
    ) {
      if (import.meta.env.VITE_APP_ENV == 'production') {
        window.location.href = `https://app.findneedle.co/requests/${prescription.request.id}?source=Rx`;
      } else {
        window.location.href = `http://localhost:5173/requests/${prescription.request.id}?source=Rx`;
      }
    }
  }, [isValidated, prescription]);

  if (!code) {
    window.location.href = 'https://app.findneedle.co';
    return null;
  }
  return (
    <div className="flex items-center justify-center w-full h-screen px-4">
      <Card className="max-w-sm mx-auto">
        <CardHeader>
          <div className="flex justify-center w-full my-8 text-center">
            <img src={Logo} alt="Needle Logo" className="h-12 " />
          </div>
          <CardTitle className="text-2xl">Hello from Needle!</CardTitle>
          <CardDescription>
            Your provider has written a new prescription for you. Please verify your birthdate to begin selecting
            pharmacies.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Verification prescription={prescription} setIsValidated={setIsValidated} setPrescription={setPrescription} />
        </CardContent>
      </Card>
    </div>
  );
};

export default Application;
